import Vue from 'vue'
import Vuex from 'vuex'
import myConst from "../util/my-const";
import fun from "../util/util";
import controlPopover from "./modules/iems/control_popover"
import ownerEms from "./modules/ems/ems_stat_monitor"
import integSysMenu from "./modules/iems/iems_menu"
import enerStorSysMenu from "./modules/ems/ems_menu"
import photovoltaicSysMenu from "./modules/photovoltaic_sys_menu"
import  statMenu from "./modules/iems/iems_station_menu"
import  button from "./modules/iems/button"
import detailWindow from './modules/iems/detail_wondown';
import CanCelRequest from "./modules/cancel_request"
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: "",
        routerList:"", //路由表
        largeScreenSelId:0, //人防菜单选中的id
    },
    mutations: {
        // 设置token
        setToken: (state, val) => {
            state.token = val;
            localStorage.setItem(myConst.keyToken, val);
        },
        //设置路由表
        setRouterList(state,list){
            state.routerList = list
            localStorage.setItem(myConst.keyRouterList, JSON.stringify(list));
        },

        //清除token
        logoutClear: (state) => {
            localStorage.clear();
            localStorage.removeItem(myConst.keyRouterList);
            localStorage.removeItem(myConst.keyToken);
            sessionStorage.clear();
            state.token = "";
            state.routerList = ""
            state.path = ""
        },
    },
    getters: {
        getToken: (state) => {
            state.token = localStorage.getItem(myConst.keyToken);
            return state.token;
        },
        //获取路由表
        getRouterList(state){
            state.routerList = JSON.parse(localStorage.getItem(myConst.keyRouterList));
            return state.routerList
        },

        //检查token是否生效
        getTokenIsEnable: (state) => {
            state.token = localStorage.getItem(myConst.keyToken);
            if (!fun.isNull(state.token)) {
                return true;
            }
            return false;
        },
    },
    actions: {},
    modules: {
        //menu      
        controlPopover,ownerEms,integSysMenu,enerStorSysMenu,photovoltaicSysMenu,statMenu,button,detailWindow,CanCelRequest
    }
})


//mutations：更改 Vuex 的 store 中的状态的唯一方法是提交 mutation。Vuex 中的 mutation 非常类似于事件：每个 mutation 都有一个字符串的 事件类型 (type) 和 一个 回调函数 (handler)。
//这个回调函数就是我们实际进行状态更改的地方，并且它会接受 state 作为第一个参数：
//actions：Action 类似于 mutation，不同在于：1、Action 提交的是 mutation，而不是直接变更状态，2、Action 可以包含任意异步操作
//modules：由于使用单一状态树，应用的所有状态会集中到一个比较大的对象。当应用变得非常复杂时，store 对象就有可能变得相当臃肿，为了解决以上问题，Vuex 允许我们将 store 分割成模块（module）。
// 每个模块拥有自己的 state、mutation、action、getter、甚至是嵌套子模块——从上至下进行同样方式的分割